module.exports = __webpack_public_path__ + "static/quiz_stages_bg-595ed041b4ea7b76aabffc0d307d02aa.svg";